import type { HTMLAttributes } from 'react';
import { forwardRef, useState } from 'react';
import { useLocale } from '@/hooks/useLocale';
import { ILocales } from '@/interfaces/locales.interfaces';
import classNames from '@/lib/classNames';
import { Switch } from '../../elements/Switch';
import { SwitchThumb } from '../../elements/Switch/Switch';

export type LocaleSwitcherProps = HTMLAttributes<HTMLDivElement>;

export const LocaleSwitcher = forwardRef<HTMLDivElement, LocaleSwitcherProps>(({ className, ...props }, ref) => {
    const [currentLocale, setLocale] = useLocale();
    const [switchOn, setSwitchOn] = useState(currentLocale !== ILocales.en_NZ);

    const handleSwitchChange = () => {
        setSwitchOn(!switchOn);
        const newLocale = switchOn ? ILocales.en_NZ : ILocales.en_AU;
        return setLocale(newLocale);
    };

    return (
        <div ref={ref} className={classNames('flex items-center space-x-2 text-white', className)} {...props} data-testid={'locale-switcher'}>
            <h6>NZ</h6>
            <Switch id="siteLocale" checked={switchOn} onCheckedChange={handleSwitchChange}>
                <SwitchThumb />
            </Switch>
            <h6>AU</h6>
        </div>
    );
});

LocaleSwitcher.displayName = 'LocaleSwitcher';
